import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveAuthData, saveUserData } from "store/reducers/login/LoginSlice";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import Cookies from "js-cookie";
import uuid from 'react-uuid';
import ToastModal from "views/components/ToastModal";

const OAuth2RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('')

  const toastUpdate = (type, message, showToast)=> {
    setToastMessageType(type)
    setToastMessage(message)
    setToast(showToast)
  }
  useEffect(() => {
    getUserToken();
  }, []);

  const getUserToken = async () => {
    const result = await apiHandler({
      url: endpoint.AUTH_LOGIN + location.search,
      headers: {
        oauth: Cookies.get("oauth"),
      },
    });
    console.log("DATA - ", result.data);
    if (result.data.error_code) {
      toastUpdate("Error", result?.data?.error_description, true)
    } else {
      // store Login Credentials
      dispatch(
        saveAuthData({
          authToken: result.data.access_token,
          refreshToken: result.data.refresh_token,
          tokenTime: Date.now(),
          isAuthenticated: true,
        })
      );
      dispatch(
        saveUserData({
          role: result.data.role ? result.data.role : "",
          username: result.data.username ? result.data.username : "",
          email: result.data.email ? result.data.email : "",
          name: result.data.name ? result.data.name : "",
        })
      );
      sessionStorage.setItem('session', uuid());
      navigate("/apps/modules");
    }
  };
  return (
    <>
        {toast && (
              <ToastModal
              toastMessage={toastMessage} 
              toastMessageType={toastMessageType} 
              toastUpdate={toastUpdate}
        />
        )}
    </>
  );
};

export default OAuth2RedirectHandler;
